/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used in labels.
 */
export const DAM_STRINGS = {
  dashboard: 'Dashboard',
  digitalAssetManagement: 'Digital asset management',
  error: `Error`,
  fileStore: 'File store',
  fileStoreDescription: 'Streamline file management for fast, safe content delivery.',
  loading: 'Loading',
  success: 'Success',
};
